import { Dispatch, SetStateAction, useCallback } from 'react'
import { BreadType } from 'types/bread'
import { CategoryType } from 'types/category'
import { filterBreadsByCategory, filterBreadsByKeyword } from 'lib/filter'

const useSelectCategoryName = (
  breads: BreadType[],
  categories: CategoryType[],
  keyword: string,
  setCategoryName: Dispatch<SetStateAction<string>>,
  setBreadList: Dispatch<SetStateAction<BreadType[]>>
): ((value: string) => void) => {
  return useCallback(
    (value: string) => {
      if (value === '' && keyword === '') {
        // カテゴリーが未選択かつキーワードも未選択であれば初期値に戻す
        setBreadList([...breads])
      } else if (value === '' && keyword !== '') {
        // カテゴリーが未選択だがキーワードが入力されている場合
        const filteredBreadsByKeyword = filterBreadsByKeyword(keyword, breads)
        setBreadList([...filteredBreadsByKeyword])
      } else {
        // カテゴリでフィルターした後にキーワードでフィルタリング
        const filteredBreadsByCategory = filterBreadsByCategory(value, categories, breads)
        const filteredBreadsByKeyword = filterBreadsByKeyword(keyword, filteredBreadsByCategory)
        setBreadList([...filteredBreadsByKeyword])
      }
      setCategoryName(value)
    },
    [breads, categories, keyword, setCategoryName, setBreadList]
  )
}

export default useSelectCategoryName
